var React = require('react');

function Inbox (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".fa-secondary{opacity:.4}")),React.createElement("path",{"d":"M376 256l-32 64H232l-32-64H76.92l85.33-128h251.5l85.33 128z","className":"fa-secondary","key":1}),React.createElement("path",{"d":"M567.94 243.91L462.25 85.37A48 48 0 0 0 422.31 64H153.69a48 48 0 0 0-39.94 21.37L8.06 243.91A48 48 0 0 0 0 270.53V400a48 48 0 0 0 48 48h480a48 48 0 0 0 48-48V270.53a48 48 0 0 0-8.06-26.62zM376 256l-32 64H232l-32-64H76.92l85.33-128h251.5l85.33 128z","className":"fa-primary","key":2})]);
}

Inbox.defaultProps = {"viewBox":"0 0 576 512","className":"icon"};

module.exports = Inbox;

Inbox.default = Inbox;
